import { Col, Row } from "antd";
import styles from "./Operation.module.scss";
import {
  AccountIcon,
  Box,
  BoxExchange,
  Calendar,
  CalendarX,
  CheckFill,
  DocumentIcon,
  DocumentPaper,
  Gas,
  Location,
  Lock,
  Mask,
  MaskConnection,
  MaskRun,
  PencilDash,
  TaskCheck,
  TaskCheckFill,
  Unlock,
  User,
  WalletPlus,
} from "../../assets/icon";
import { useRecoilValue } from "recoil";
import { UserAtom } from "../../store";
import { checkPermissions } from "../../utils/checkPermissions";

const Operation = () => {
  //Define constant
  const permissionState = useRecoilValue<any>(UserAtom.permissions);
  const features = permissionState?.features;
  const menu = [
    {
      group: "Common",
      color: "#3a538a",
      items: [
        {
          title: "Mã tuyến",
          icon: <DocumentIcon color="white" size={50} />,
          badge: 0,
          link: "/common/router-manager",
          disabled:
            !checkPermissions("FIXED_ROUTE_SALARY", "view", features) &&
            !checkPermissions("ROUTE_BASE", "view", features),
        },
        {
          title: "Cước doanh thu",
          icon: <WalletPlus color="white" size={50} />,
          badge: 0,
          link: "/common/freight-revenue",
          disabled: !checkPermissions("FREIGHT", "view", features),
        },
        {
          title: "Cước thầu phụ",
          icon: <CalendarX color="white" size={50} />,
          badge: 0,
          link: "/common/freight-costs?tabs=1",
          disabled: !checkPermissions("CONTRACTOR_FREIGHT", "view", features),
        },
        {
          title: "Nhóm thầu phụ",
          icon: <CalendarX color="white" size={50} />,
          badge: 0,
          link: "/common/freight-costs?tabs=2",
          disabled: !checkPermissions(
            "CONTRACTOR_FREIGHT_GROUP",
            "view",
            features,
          ),
        },
        {
          title: "Khách hàng",
          icon: <AccountIcon color="white" size={50} />,
          badge: 0,
          link: "/common/customer",
          disabled: !checkPermissions("CUSTOMER", "view", features),
        },
        {
          title: "Nhà thầu",
          icon: <MaskRun color="white" size={50} />,
          badge: 0,
          link: "/common/contructor",
          disabled: !checkPermissions("CONTRUCTOR", "view", features),
        },
        {
          title: "Phương tiện",
          icon: <Mask color="white" size={50} />,
          badge: 0,
          link: "/common/vehicle",
          disabled: !checkPermissions("VEHICLE", "view", features),
        },
        {
          title: "Phân bổ",
          icon: <BoxExchange color="white" size={50} />,
          link: "/allocation-cost",
          badge: 0,
          disabled: !checkPermissions("ALLOCATION", "view", features),
        },
        { title: "Uỷ thác", icon: <Box color="white" size={50} />, badge: 0 },
      ],
    },
    {
      group: "Operation",
      color: "#b61259",
      items: [
        {
          title: "PAKD",
          icon: <TaskCheckFill color="white" size={50} />,
          badge: 2,
          link: "/business-plan",
          disabled: !checkPermissions("BUSSINESS_PLAN", "view", features),
        },
        {
          title: "Đơn hàng",
          icon: <Location color="white" size={50} />,
          badge: 0,
          link: "/operation/orders?tabs=1",
          disabled: !checkPermissions("ORDER_CREATION", "view", features),
        },
        {
          title: "Điều xe",
          icon: <MaskConnection color="white" size={50} />,
          badge: 0,
          link: "/operation/orders?tabs=2",
          disabled: !checkPermissions("ORDER_DISPATCHING", "view", features),
        },
        {
          title: "Hoá đơn",
          icon: <DocumentPaper color="white" size={50} />,
          badge: 3,
        },
        {
          title: "Nhiên liệu",
          icon: <Gas color="white" size={50} />,
          badge: 0,
          link: "/operation/oil",
          disabled: !checkPermissions("FUEL", "view", features),
        },
        {
          title: "Sửa chữa",
          icon: <CalendarX color="white" size={50} />,
          badge: 1,
          link: "/operation/repair",
          disabled: !checkPermissions("REPAIRS", "view", features),
        },
        {
          title: "Chấm công",
          icon: <Calendar color="white" size={50} />,
          badge: 0,
        },
        {
          title: "Chi phí phát sinh",
          icon: <PencilDash color="white" size={50} />,
          badge: 1,
          link: "/operation/incurred-costs?tabs=1",
          disabled: !checkPermissions("INCURRED", "view", features),
        },
      ],
    },
    {
      group: "Report",
      color: "#3a53ba",
      items: [
        {
          title: "Báo cáo",
          icon: <TaskCheck color="white" size={50} />,
          badge: 0,
          link: "/report/report-list",
          disabled: !checkPermissions("REPORT_SHEET", "view", features),
        },
        {
          title: "Chốt chuyến",
          icon: <CheckFill color="white" size={50} />,
          badge: 0,
          link: "/operation/trip-closing",
          disabled: !checkPermissions("LOCK_DATA", "view", features),
        },
        {
          title: "Khoá dữ liệu",
          icon: <Lock color="white" size={50} />,
          badge: 0,
          link: "/operation/data-locks",
          disabled: !checkPermissions("LOCK_DATA", "view", features),
        },
      ],
    },
    {
      group: "Cài đặt",
      color: "#3a53ba",
      items: [
        {
          title: "User",
          icon: <User color="white" size={50} />,
          badge: 0,
          link: "/setting?tabs=1",
          disabled: !checkPermissions("USERS", "view", features),
        },
        {
          title: "Phân quyền",
          icon: <Unlock color="white" size={50} />,
          badge: 0,
          link: "/setting?tabs=3",
          disabled: !checkPermissions("USER_GROUPS", "view", features),
        },
      ],
    },
  ];
  //Function to render
  const renderItems = (item: any, color: string) => {
    return (
      <div
        className={styles.Items}
        onClick={() => {
          if (!item.link || item.disabled) return;
          window.location.href = item.link;
        }}
        style={{
          cursor: item.link && !item.disabled ? "pointer" : "not-allowed",
        }}
      >
        <div
          className={styles.Icon}
          style={{
            backgroundColor: item.link && !item.disabled ? color : "#646262",
          }}
        >
          {item.icon}
        </div>
        <div className={styles.Title}>{item.title}</div>
      </div>
    );
  };
  const renderGroup = () => {
    return menu.map((group, key) => {
      const items = group.items;
      return (
        <div className={styles.Group} key={key}>
          <div className={styles.GroupHeader}>{group.group}</div>
          <Row className={styles.ListItems}>
            {items.map((ite, key2) => (
              <Col key={key2} className={styles.WarpItem}>
                {renderItems(ite, group.color)}
              </Col>
            ))}
          </Row>
        </div>
      );
    });
  };
  //Main render
  return <div className={styles.Operation}>{renderGroup()}</div>;
};

export { Operation };
